// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:05:12

export default {
  "id": "elemental-monsters-merge-and-evolution",
  "slug": "elemental-monsters-merge-and-evolution",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e388e07ac5da4a27b5ec727572816213-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e388e07ac5da4a27b5ec727572816213/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Elemental Monsters: Merge & Evolution",
      "description": "Welcome to the world of \"Elemental Monsters: Merge & Evolution\"! This free online game is perfect for children and teenagers. Develop your logic and strategic thinking while taking part in epic battles with monsters. You will control an army of fire, water, earth and air elementals in an exciting battle to liberate their worlds.",
      "instructions": "⚔️Battles: Take part in battles and defeat opponents to earn coins.\n?Coins: Use coins to buy, sell and upgrade your heroes.\n?Units: Each unit has unique characteristics such as health, damage and attack speed.\n?Merge: Combine units to create a more powerful monster. You can also combine units from different elements to create unique warriors.\n?Chests: Don't forget to open chests to get extra coins and bonuses.",
      "genres": [
        "Casual",
        "Merge"
      ],
      "tags": [
        "2d",
        "endless",
        "fire",
        "timekiller",
        "water"
      ]
    },
    "zh-CN": {
      "title": "元素怪物：融合与进化",
      "description": "欢迎来到“元素怪物：融合与进化”的世界！这款免费在线游戏非常适合儿童和青少年。在参与史诗般的怪物战斗的同时，锻炼你的逻辑和战略思维。你将操控一支由火、水、土和空气元素构成的军队，在一场激动人心的战斗中解放他们的世界。",
      "instructions": "⚔️战斗：参与战斗，击败对手以赚取金币。\n?金币：使用金币购买、出售和升级你的英雄。\n?单位：每个单位都有独特的特性，如生命值、伤害和攻击速度。\n?融合：将单位组合以创造更强大的怪物。你还可以将不同元素的单位组合在一起，创造独特的战士。\n?宝箱：别忘了打开宝箱以获得额外金币和奖励。",
      "genres": [
        "休闲",
        "合并"
      ],
      "tags": [
        "2D",
        "无尽",
        "火焰",
        "时间杀手",
        "水"
      ]
    },
    "zh-TW": {
      "title": "元素怪物：合併與進化",
      "description": "歡迎來到「元素獸：合併與進化」的世界！這款免費在線遊戲非常適合兒童和青少年。在參與與怪物們的經典戰鬥的同時，發展你的邏輯和策略思維。你將操控一支火、水、土和風元素的軍隊，在刺激的戰鬥中解放他們的世界。",
      "instructions": "⚔️戰鬥：參與戰鬥，擊敗對手以獲得硬幣。\n?硬幣：使用硬幣購買、賣出和升級你的英雄。\n?單位：每個單位都有獨特的特徵，如血量、傷害和攻擊速度。\n?合併：合併單位以創造更強大的怪物。你也可以合併不同元素的單位來創造獨特的戰士。\n?櫃子：不要忘了打開櫃子以獲得額外的硬幣和獎勵。",
      "genres": [
        "休闲",
        "合併"
      ],
      "tags": [
        "2D",
        "無限",
        "火",
        "時間殺手",
        "水"
      ]
    },
    "zh-HK": {
      "title": "元素獸：合併與進化",
      "description": "歡迎來到「元素怪物：合併與進化」的世界！這款免費在線遊戲適合兒童和青少年玩。在參與與怪物們的經典戰鬥的同時，培養你的邏輯和策略思維。你將操控火、水、土和風元素的軍隊，在刺激的戰鬥中解放他們的世界。",
      "instructions": "⚔️戰鬥：參與戰鬥，擊敗對手以贏取硬幣。\n?硬幣：使用硬幣購買、賣出及升級你的英雄。\n?單位：每個單位都有獨特的特性，如生命值、傷害和攻擊速度。\n?合併：將單位合併以創造更強大的怪物。你也可以合併不同元素的單位以創造獨特的戰士。\n?監獄：别忘了打開監獄以獲得額外硬幣和獎勵。",
      "genres": [
        "隨意",
        "合併"
      ],
      "tags": [
        "2D",
        "無限",
        "火",
        "時間消磨者",
        "水"
      ]
    },
    "ja": {
      "title": "元素モンスター：合体と進化",
      "description": "「Elemental Monsters: Merge & Evolution」の世界へようこそ！この無料オンラインゲームは、子供や十代の間に人気があります。論理と戦略的な思考を鍛えながら、怪物との壮大な戦闘に参加しましょう。火、水、土、風の元素種族の軍を統率し、彼らの世界を解放する興味深い戦いに挑戦してください。",
      "instructions": "🗡️バトル：バトルに参加し、敵を倒してコインを稼ぎましょう。\n?コイン：コインを使ってヒーローを購入、売却、アップグレードします。\n?ユニット：各ユニットには健康、ダメージ、攻撃速度などのユニークな特性があります。\n?合体：ユニットを合体させてより強力なモンスターを作成します。また、異なる要素のユニットを合体させてユニークな戦士を作成することもできます。\n?宝箱：コインやボーナスをゲットするために、宝箱を開けることを忘れずに。",
      "genres": [
        "カジュアル",
        "マージ"
      ],
      "tags": [
        "2D",
        "無限",
        "火",
        "時間殺し",
        "水"
      ]
    },
    "ko": {
      "title": "요소 야생수: 합성 & 진화",
      "description": "\"엘리멘탈 몬스터: 메이지 & 진화\"의 세상을 환영합니다! 이 무료 온라인 게임은 아이들과 청소년들에게 완벽합니다. 몬스터와의 전쟁에 참여하면서 논리적 사고와 전략적 사고를 개발하세요. 불, 물, 토, 공 요소의 요정으로 구성된 부대를 이끌고, 그들의 세계를 해방하는 흥미로운 전투에 참여하세요.",
      "instructions": "⚔️전투: 전투에 참여하여 상대를 꺾고 코인을 얻으세요.\n?코인: 코인을 사용하여 영웅을 구매, 판매하고 업그레이드하세요.\n?유닛: 각 유닛은 건강, 데미지, 공격 속도와 같은 독특한 특성을 가지고 있습니다.\n?결합: 유닛을 결합하여 더 강력한 몬스터를 만들 수 있습니다. 또한, 다른 요소의 유닛을 결합하여 독특한 전사를 만들 수 있습니다.\n?보석箱: 추가 코인과 보너스를 얻기 위해 보석箱을 열지 마세요.",
      "genres": [
        "캐주얼",
        "합성"
      ],
      "tags": [
        "2D",
        "끝없는",
        "불",
        "시간쟁이",
        "물"
      ]
    },
    "fr": {
      "title": "Monstres Élémentaires : Fusion & Évolution",
      "description": "Bienvenue dans le monde d' \"Elemental Monsters: Merge & Evolution\" ! Ce jeu en ligne gratuit est parfait pour les enfants et les adolescents. Développez votre logique et votre pensée stratégique tout en prenant part à des batailles épiques avec des monstres. Vous contrôlerez une armée d'élémentaires de feu, d'eau, de terre et d'air dans une bataille captivante pour libérer leurs mondes.",
      "instructions": "⚔️Combats : Participez aux combats et battez vos adversaires pour gagner des pièces.\n?Pièces : Utilisez les pièces pour acheter, vendre et améliorer vos héros.\n?Unités : Chaque unité possède des caractéristiques uniques telles que la santé, les dégâts et la vitesse d'attaque.\n?Fusion : Combinez des unités pour créer des monstres plus puissants. Vous pouvez également combiner des unités de différents éléments pour créer des guerriers uniques.\n?Coffres : N'oubliez pas d'ouvrir les coffres pour obtenir des pièces supplémentaires et des bonus.",
      "genres": [
        "Casual",
        "Fusion"
      ],
      "tags": [
        "2D",
        "infini",
        "feu",
        "temps-killer",
        "eau"
      ]
    }
  }
};
